import { Checkbox, FormControlLabel, List, ListItem } from '@mui/material'
import React from 'react'

const SelectDamagedSectionTypes = ({ handleChange, damageTypeOptions }) => {
  return (
    <List>
      {damageTypeOptions?.map((type) => (
        <ListItem
          sx={{
            padding: (theme) => theme.spacing(0.375, 1),
          }}
          key={type}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={damageTypeOptions[type[1]]}
                onChange={handleChange}
                name={type[1]}
                color="primary"
                sx={{
                  color: (theme) => theme.palette.text.darkSecondary,
                  marginRight: (theme) => theme.spacing(2.875),
                }}
              />
            }
            sx={{
              fontSize: '0.875rem',
            }}
            label={type[0]}
          />
        </ListItem>
      ))}
    </List>
  )
}

export default SelectDamagedSectionTypes
